export enum DynamicSelectIdentifier {
  BillingOptions,
  Companies,
  ContractCancellationReasons,
  ContractCommentTypes,
  CustomerLanguages,
  CustomerStatuses,
  CustomerTypes,
  CVIs,
  DocumentStatuses,
  EdocTypes,
  EscrowOfficeGroups,
  EscrowOfficerStatuses,
  EscrowOfficeStatuses,
  EscrowOfficerTypes,
  InvoicePaymentFilters,
  PhoneTypes,
  PropertyManamentOfficeStatuses,
  PropertyManagerStatuses,
  PropertyManagerTypes,
  RealEstateAgentRatings,
  RealEstateAgentStatuses,
  RealEstateAgentTypes,
  RealEstateOfficeEOCarriers,
  RealEstateOfficeGroups,
  RealEstateOfficeStatuses,
  ServiceRequestTypes,
  ServiceWorkOrderBrands,
  ServiceWorkOrderCallReasons,
  ServiceWorkOrderRedispatchTypes,
  ServiceWorkOrderStatuses,
  ServiceWorkOrderTypes,
  SWODispatchFilterByStatus,
  SWODispatchFilterByTrade,
  SWOPurchaseRequestTypes,
  TransactionCoordinatorStatuses,
  TransactionCoordinatorTypes,
  USStates,
  USFacilityStates,
  VendorAgreementTypes,
  VendorGroups,
  VendorStatuses,
  VendorTypes,
  VendorW9Statuses,
  GetNoRenewReasons,
  Suppliers,
  SuppliersHvac,
  Facilities,
  Colors,
  GLCodes,
  SwoLineTypes,
  CILReasons,
  Fuel,
  HvacSystemTypes,
  HvacParts,
  HvacVendorLocations,
  InvoiceStatuses,
  VendorDocumentTypes
}



// WEBPACK FOOTER //
// ./src/common/components/dynamic-select/dynamic-select-types.tsx